/**
 * Filename for the Stably agent's environment file.
 * We use .stably-agent.env instead of .env to avoid collisions with user's own .env files in BYOR repos.
 */
export const STABLY_AGENT_ENV_FILENAME = '.stably-agent.env';

/**
 * Centralized version constants for all Stably products.
 *
 * These are the single source of truth — consumed by the app, CLI, and product manifests.
 * When bumping versions, update them here only.
 */

/**
 * The supported Playwright version for Stably's browser infrastructure.
 * This is the exact version that must be installed — version ranges are not allowed.
 *
 * IMPORTANT: If you need to update this version:
 * 1. Update packages/browser/package.json to the new version
 * 2. Create/update the patch file in app/src/stand-alone/codegen-agent/templates/patches/
 * 3. Update SUPPORTED_PLAYWRIGHT_PATCHES in apply-playwright-patch.ts
 */
export const SUPPORTED_PLAYWRIGHT_VERSION = '1.58.0';

/** Published version of the @stablyai/playwright-test SDK. */
export const STABLY_SDK_VERSION = '2.1.16';

/** Version of the @stablyai/email SDK. */
export const STABLY_EMAIL_SDK_VERSION = '0.1.2';

/** Minimum @stablyai/playwright-test version range for dependency injection. */
export const STABLY_PLAYWRIGHT_TEST_MIN_VERSION = `^${STABLY_SDK_VERSION}`;
